import type { StoryblokImage } from '@cinch-nx/data-storyblok'
import {
  Carousel,
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
} from '@cinch-nx/shared-ui'
import Image from 'next/legacy/image'

import styles from './image-carousel.module.css'

export interface Props {
  images: StoryblokImage[]
}

const carouselSettings = {
  name: 'partnerships-images',
  ariaLabels: {
    previous: 'Go to previous slide',
    next: 'Go to next slide',
  },
  swiperSettings: {
    spaceBetween: 0,
    slidesPerView: 1,
  },
}

const ImageCarousel: React.FC<Props> = ({ images }) => (
  <>
    <Carousel
      name={carouselSettings.name}
      swiperSettings={carouselSettings.swiperSettings}
      customClassNames={{
        carousel: styles.carousel,
      }}
    >
      {images
        .filter((image: StoryblokImage) => image?.filename)
        ?.map((image: StoryblokImage, idx) => (
          <CarouselSlide key={image.id}>
            <div className={styles.imageWrapper}>
              <Image
                src={image.filename}
                alt={image.alt ?? undefined}
                layout="fill"
                objectPosition="40%"
                objectFit="cover"
                // This is a full width image and therefore the largest contentful paint LCP.
                // Eagerly load the first image and lazy load the others.
                priority={idx === 0}
              />
            </div>
          </CarouselSlide>
        ))}
    </Carousel>
    <CarouselControls customClassNames={styles.carouselControls}>
      <CarouselPagination name={carouselSettings.name} />
      <CarouselNavigation
        name={carouselSettings.name}
        ariaLabels={carouselSettings.ariaLabels}
        customClassNames={{
          prevButton: styles.carouselNavButton,
          nextButton: styles.carouselNavButton,
        }}
      />
    </CarouselControls>
  </>
)

export default ImageCarousel
